import ActionCard from "components/shared/ActionCard";
import TitleSeparation from "components/shared/TitleSeparation";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

import styles from "../style.module.scss";
import type { DeclarationsCardsData } from "../utils";

interface IUpcomingDeclarations {
    /**
     * Upcoming declarations data.
     */
    cards: DeclarationsCardsData[];
}

/**
 * Block within DeclarationPage for all upcoming declarations.
 */
const UpcomingDeclarations = ({ cards }: IUpcomingDeclarations) => {
    const [t] = useTranslation();

    return (
        <div className={styles["upcoming-declarations"]}>
            <TitleSeparation title={t("Declarations.UpcomingDeclarations")} />
            {cards.length > 0 ? (
                <div className={styles["cards-container"]}>
                    {cards.map((card) => {
                        return <ActionCard {...card} isCompact key={`upcoming-card-${uuidv4()}`} />;
                    })}
                </div>
            ) : (
                <span className={styles["no-history-info"]}>{t("Declarations.NoUpcoming")}</span>
            )}
        </div>
    );
};

export default UpcomingDeclarations;
